import { Injectable } from '@angular/core';
import {
  TranslateService as NgxTranslateService,
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';

/**
 * Fehlende Übersetzungen werden im localStorage unter "dlp_missing_trans_<lang>"
 * gespeichert und als Fallback mit dem Schlüssel selbst zurückgegeben.
 * So können Entwickler fehlende Begriffe leicht exportieren und in die JSON-Dateien übernehmen.
 */
@Injectable()
export class DlpMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const lang = params.translateService.currentLang || 'de';
    try {
      const storageKey = 'dlp_missing_trans_' + lang;
      const raw = localStorage.getItem(storageKey);
      const missing: Record<string, string> = raw ? JSON.parse(raw) : {};
      if (!missing[params.key]) {
        missing[params.key] = params.key;
        localStorage.setItem(storageKey, JSON.stringify(missing));
      }
    } catch {
      // localStorage nicht verfügbar – ignorieren
    }
    return params.key;
  }
}

/**
 * Wrapper um @ngx-translate/core mit identischer API zum bisherigen eigenen Service.
 * Alle bestehenden Komponenten (instant / | translate) bleiben unverändert.
 */
@Injectable()
export class TranslateService {

  constructor(private _ngx: NgxTranslateService) { }

  public get currentLang(): string {
    return this._ngx.currentLang;
  }

  public use(lang: string): void {
    this._ngx.use(lang);
  }

  private translate(key: string, capitalized: boolean = false): string {
    const translation = this._ngx.instant(key);
    if (capitalized && translation && translation.length > 0) {
      return translation.charAt(0).toUpperCase() + translation.slice(1);
    }
    return translation;
  }

  public instant(key: string, capitalized: boolean = false): string {
    return this.translate(key, capitalized);
  }

  /** Gibt alle im localStorage gespeicherten fehlenden Begriffe zurück (Debug-Hilfsmittel). */
  public getMissingKeys(lang: string = this.currentLang): Record<string, string> {
    try {
      const raw = localStorage.getItem('dlp_missing_trans_' + lang);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }
}
